module.exports = __webpack_public_path__ + "img/Listening.66cfb0cb.svg";